import type { FireAnalyticsFn as FireShortcutAnalyticsFn } from '@atlassian/jira-software-keyboard-shortcuts/src/utils/analytics/index.tsx';

export const CARD_NEXT = 'state.actions.cards.navigate.CARD_NEXT' as const;

export type CardNext = {
	type: typeof CARD_NEXT;
	payload: {
		fireShortcutAnalyticsFn: FireShortcutAnalyticsFn;
	};
};

export const cardNext = (fireShortcutAnalyticsFn: FireShortcutAnalyticsFn): CardNext => ({
	type: CARD_NEXT,
	payload: {
		fireShortcutAnalyticsFn,
	},
});

export const CARD_PREV = 'state.actions.cards.navigate.CARD_PREV' as const;

export type CardPrev = {
	type: typeof CARD_PREV;
	payload: {
		fireShortcutAnalyticsFn: FireShortcutAnalyticsFn;
	};
};

export const cardPrev = (fireShortcutAnalyticsFn: FireShortcutAnalyticsFn): CardPrev => ({
	type: CARD_PREV,
	payload: {
		fireShortcutAnalyticsFn,
	},
});

export type Action = CardNext | CardPrev;
